import { render } from "./MobileNotificationCenterUnauthorizedUser.vue?vue&type=template&id=2b832d89"
import script from "./MobileNotificationCenterUnauthorizedUser.vue?vue&type=script&lang=js"
export * from "./MobileNotificationCenterUnauthorizedUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__